import { h } from '@logicflow/core';

const FILL = '#fff0f6';
const STROKE = '#c41d7f';

export function renderAiChip(x, y, width, height, props) {
  const aiKind = props?.aiKind;
  const isAgent = !!props?.isAiAgent;
  if (!aiKind && !isAgent) return null;

  const label = isAgent ? 'AI·AGT' : 'AI';
  const bw = isAgent ? 32 : 18;
  const bh = 12;
  const l = x + width / 2 - bw - 4;
  const t = y - height / 2 + 4;

  return h('g', { style: 'pointer-events:none;user-select:none;' }, [
    h('rect', {
      x: l, y: t, width: bw, height: bh, rx: 3, ry: 3,
      fill: FILL, stroke: STROKE, strokeWidth: 1,
    }),
    h('text', {
      x: l + bw / 2,
      y: t + bh / 2 + 3,
      textAnchor: 'middle',
      fontSize: 8,
      fontWeight: 700,
      fill: STROKE,
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    }, label),
  ]);
}
